export const OK = 1001

export const ERROR = 1002

export const DATA_ERROR = 1003

export const AUTHENTICATION_FAILURE = 1004

export const AUTHENTICATION_ERROR = 1005

export const AUTHENTICATION_TOKEN_ERROR = 1006

export const AUTHORIZATION_ERROR = 1007


// WEBPACK FOOTER //
// ./src/api/response-status.js